// extracted by mini-css-extract-plugin
export var orderSummary = "_ta-0";
export var showMoreLessButton = "_ta-1";